import { CloseCircleFilled } from '@ant-design/icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWarning } from '@fortawesome/free-solid-svg-icons';
import { ERROR_COLOR } from '@/shared/constants/colors';

export const issuesConfig = {
  error: {
    icon: <CloseCircleFilled />,
    color: ERROR_COLOR,
    label: {
      singular: 'Error',
      plural: 'Errores',
    }
  },
  alert: {
    icon: <FontAwesomeIcon icon={faWarning} />,
    color: '#fa8714',
    label: {
      singular: 'Alerta',
      plural: 'Alertas',
    }
  },
  inconsistency: {
    icon: <FontAwesomeIcon icon={faWarning} />,
    color: '#faad14',
    label: {
      singular: 'Inconsistencia',
      plural: 'Inconsistencias',
    }
  },
};